import { LmsIconKind, LmsProvider } from './types';

export interface AssignmentLmsFields {
  connected_to_canvas?: boolean;
  connected_to_google?: boolean;
  connected_to_schoology?: boolean;
  lms_provider?: LmsProvider | null;
  lms_type?: string | null;
}

// LTI 1.3 rows carry the vendor on lms_provider; the booleans only identify the Canvas API and Google paths.
const assignmentLmsKind = (assignment: AssignmentLmsFields): LmsIconKind | null => {
  if (assignment.lms_type === 'LTI') return assignment.lms_provider?.kind ?? null;
  if (assignment.connected_to_google) return 'google';
  if (assignment.connected_to_canvas) return 'canvas';
  if (assignment.connected_to_schoology) return 'schoology';

  return null;
};

export default assignmentLmsKind;
